var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"placeholder"},[_c('div',{staticClass:"carousel columns-4"},_vm._l((4),function(i){return _c('div',{staticClass:"card tapered-shadow item-loading"},[_c('div',{staticClass:"fill"})])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }